import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { RoutesFacade, RouteDirectionFacade } from '@ridango/components';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'rwidget-schedule-route-direction',
    templateUrl: './route-direction.component.html',
})
export class ScheduleRouteDirectionComponent implements OnInit, OnDestroy {
    @Input() routeId: number;

    private componentDestroyed$ = new Subject<void>();

    routeName: string = null;
    routeDirections = null;
    routeDirectionIds = [];

    constructor(
        private routesFacade: RoutesFacade,
        private routeDirectionFacade: RouteDirectionFacade,
        private router: Router,
        private translate: TranslateService
    ) {}

    ngOnInit() {
        this.routesFacade.setSelectedRouteId(this.routeId);
        this.routeDirectionFacade.setSelectedRouteDirection(null);

        this.routeDirectionFacade
            .getRouteDirections(this.routeId)
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe((directions) => {
                if (directions) {
                    this.routeDirections = directions;
                    this.routeDirectionIds = Object.keys(this.routeDirections).sort();

                    // skip directions list and redirect to only direction available
                    if (this.routeDirectionIds.length === 1) {
                        this.router.navigate([
                            this.translate.currentLang,
                            'schedule',
                            'routes',
                            this.routeId,
                            'directions',
                            this.routeDirectionIds[0],
                        ]);
                    }
                }
            });
    }

    selectDirectionId(id: number) {
        this.routeDirectionFacade.setSelectedRouteDirection(id);
    }

    ngOnDestroy() {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }
}
